import { Link } from "@reach/router";
import { AvFeedback, AvField, AvForm, AvGroup, AvInput } from 'availity-mobx-reactstrap-validation';
import NormalButton from 'js/components/common/Button/NormalButton';
import CheckIcon from 'js/components/core/Icons/CheckIcon';
import EditIcon from 'js/components/core/Icons/EditIcon';
import UserLogoIcon from 'js/components/core/Icons/UserLogoIcon.js';
import { darkGreyColor, greenColor } from 'js/config/style';
import { formatCurrency } from 'js/services/Format';
import { url } from "js/services/Network";
import { validateCheckoutName } from 'js/services/Regex';
import UserCountry from 'js/services/UserCountry';
import AppState from "js/stores/AppState";
import AppUser from "js/stores/AppUser";
import { default as FormState } from 'js/stores/pages/MyAccountPageState/UserDetails';
import { getSnapshot } from 'mobx-state-tree';
import React, { useEffect, useRef, useState } from 'react';
import { Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import styled from 'styled-components';

const CheckIconComponent = styled(CheckIcon)`
  width: 1rem;
  margin: 0 5px;
`;

const EditIconComponent = styled(EditIcon)`
  position: relative;
  left: 5px;
  bottom: 2px;
  cursor: pointer;
`;

const OffcanvasAuth = ({show, toggle}) => {
  const { name, login, balance } = AppUser;
  const currentPage = AppState.currentPage;
  const [avatarError,setAvatarError] = useState('');

  const fileInput = useRef(null);

  const handleFileChange = (event, values) => {
    const file = event.target.files[0];
    if (!file) {
      return;
    }

    let errorMessage = '';

    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];
    if (!allowedTypes.includes(file.type)) {
      errorMessage = 'Please upload an image file (jpg, png, gif).';
    }

    const maxSizeInBytes = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSizeInBytes) {
      errorMessage = 'File size should not exceed 5MB.';
    }

    if (errorMessage) {
      setAvatarError({ avatarError: errorMessage });
    } else {
      setAvatarError({ avatarError: '' });

      form.uploadAvatar(file);
    }
  };
  const [checkoutName,setCheckoutName] = useState(login);
  const [editing,setEditing] = useState(false);
  const containerRef = useRef(null);
  const [displayCheckMark,setDisplayCheckMark] = useState(false);
  const [form, setForm] = useState();
  const [displayWarning,setDisplayWarning] = useState(false);

  useEffect(()=>{
    setForm(FormState.create(getSnapshot(AppUser)));
  },[]);

  // const form = FormState.create(getSnapshot(AppUser));

  const changeCheckoutField = () => {
    setEditing(prev => !prev);
  };

  const handleClickOutside = (event) => {
     if (containerRef.current && !containerRef.current.contains(event.target)) {
      setEditing(false);
       setDisplayCheckMark(false);
     }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const submitForm = () => {
    form.setWasSubmitted() &&
    form.canUpdateLogin &&
    form.updateLogin().then(user => {
      setDisplayWarning(false);
      AppUser.setDetails(user);
      form.onComplete(user);
      setDisplayCheckMark(true);
    }).catch((e)=>{
      setDisplayCheckMark(false);
      setDisplayWarning(true);
    });

  }

  const inputOnChange = (e) => {
    form.user.setLogin(e.target.value);
    setDisplayCheckMark(false);
    setDisplayWarning(false);
  }

  return (
    <Offcanvas
      direction="end"
      isOpen={show}
      toggle={toggle}
    >
      <OffcanvasHeader toggle={toggle}>
        <div ref={containerRef} style={{display: '-webkit-inline-box'}}>
          <AvForm>
            <UserLogoIcon color={darkGreyColor} style={{cursor:'pointer'}} onClick={() => fileInput.current && fileInput.current.click()}/>
            <AvField
              type="file"
              name="avatar"
              accept="image/jpeg, image/png, image/gif"
              style={{ display: 'none' }}
              innerRef={fileInput}
              onChange={handleFileChange}
              errorMessage={avatarError}
              validate={{
                required: { value: false }
              }}
            />
          </AvForm>
          <div style={{marginLeft: '5px', display: '-webkit-inline-box'}}>
            @{
            editing ?
              <AvForm>
                <AvGroup>
                  <AvInput className="custom-input-height" name="checkout_name"
                           id="checkout_name"
                           value={form.user.login || ''}
                           onChange={(e)=>inputOnChange(e)}
                           placeholder="Your checkout name"
                           required
                           validate={validateCheckoutName} />
                  <AvFeedback><small>Please enter valid checkout name</small></AvFeedback>
                  {displayWarning &&
                    <div style={{width:'100%',marginTop:'0.25rem',fontSize:'.875em',color:'#dc3545'}} ><small>Checkout name already exists</small></div>
                  }
                </AvGroup>
              </AvForm>
              : <>{login}</>
          }
          {editing || <EditIconComponent onClick={changeCheckoutField} />}
          {editing && !displayCheckMark && <NormalButton className="normal-class" onClick={submitForm}>Save</NormalButton>}
          {displayCheckMark && <CheckIconComponent color={greenColor} />}
        </div>
        </div>
      </OffcanvasHeader>
      <Link
        to={url('my-account-page')}
        active={!AppUser.isLoggingOut && currentPage === 'MyAccountPage'}
        onClick={toggle}
        style={{marginLeft:'16px'}}>
        Manage account
      </Link>
      <OffcanvasBody>
        <ul className="desktop-menu">
          <li className="balance d-flex align-items-center justify-content-between">
            <div>Balance</div>
            <div className={balance < 0 ? 'text-danger' : balance === 0 ? 'text-gray' : 'text-success'}>{formatCurrency(balance, UserCountry() === 'NG' ? 'NGN' : 'USD')}</div>
          </li>
          {AppUser.hasRole('admin') && (
            <li>
              <Link
                to={url('home-page')}
                active={!AppUser.isLoggingOut && currentPage === 'AdminDashboardPage'}
                onClick={toggle}>
                Admin dashboard
              </Link>
            </li>
          )}
          <li>
            <Link
              to={url('user-dashboard-page')}
              active={!AppUser.isLoggingOut && currentPage === 'UserDashboardPage'}
              onClick={toggle}>
              Dashboard
            </Link>
          </li>
          <li>
            <Link
              to={url('my-account-page')}
              active={!AppUser.isLoggingOut && currentPage === 'MyAccountPage'}
              onClick={toggle}>
              My account
            </Link>
          </li>
          <li>
            <Link
              to={url('email-preferences-page')}
              active={!AppUser.isLoggingOut && currentPage === 'EmailPreferencesPage'}
              onClick={toggle}>
              Email preferences
            </Link>
          </li>
          <li>
            <Link
              onClick={event => {
                event.preventDefault();
                AppUser.logoutUser().then(toggle);
              }}
              to={url('logout-page')}
              busy={AppUser.isLoggingOut ? 1 : 0}>
              {AppUser.isLoggingOut ? 'Logging out' : 'Logout'}
            </Link>
          </li>
        </ul>
      </OffcanvasBody>
    </Offcanvas>
  );
}

export default OffcanvasAuth;
